class productComparison {
  constructor(parent) {
    if (!parent) {
      return;
    }
    this.parent = parent;
    this.init();
  }

  setmaxHeight = () => {
    let parent = this.parent;
    const items = parent.querySelectorAll('.comparison-with-product-content-item');

    // Get the maximum height
    let maxHeight = 0;
    items.forEach(item => {
      const itemHeight = item.offsetHeight;
      if (itemHeight > maxHeight) {
        maxHeight = itemHeight;
      }
    });

    // Set the maximum height for all items
    items.forEach(item => {
      item.style.height = `${maxHeight}px`;
    });
  }

  init = () => {
    this.setmaxHeight();
  }
}
new productComparison(document.querySelector('.comparison-with-product'));